import { ChevronDown } from '@/components/ui/icons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

import {
  pickerContentClass,
  pickerHeroItemBaseClass,
  pickerHeroWrapperClass,
  pickerItemActiveClass,
  pickerItemInactiveClass,
  pillWidthClass,
} from '../dropdownStyles';

import { DOMAINS, Domain } from './data';

interface DomainDropdownProps {
  vehicleTab: string;
  currentDomain: Domain;
  currentLabel: string | null;
  currentHero: string | undefined;
  handleDomainSelect: (domain: Domain) => void;
}

export function DomainDropdown({
  vehicleTab,
  currentDomain,
  currentLabel,
  currentHero,
  handleDomainSelect,
}: DomainDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            pillWidthClass,
            'flex items-center justify-between gap-3 self-stretch overflow-hidden rounded-md border border-[#737373] px-4 text-sm transition-colors hover:bg-telekinesis-neutral-950',
          )}
        >
          <div className="flex min-w-0 flex-1 flex-col items-start">
            <span className="w-full truncate text-xs font-medium text-telekinesis-text-secondary">
              Vehicle Domain:
            </span>
            <span
              className={cn(
                'w-full truncate',
                currentLabel
                  ? 'font-semibold text-[#107d40]'
                  : 'font-medium text-telekinesis-text-secondary',
              )}
            >
              {currentLabel ?? 'Select Domain'}
            </span>
          </div>
          {currentHero && (
            <div className="flex w-14 flex-shrink-0 items-center justify-center self-stretch">
              <img
                src={currentHero}
                alt=""
                aria-hidden="true"
                className="h-full object-contain"
                style={
                  vehicleTab === 'sea' || vehicleTab === 'space'
                    ? { transform: 'scaleX(-1)' }
                    : undefined
                }
              />
            </div>
          )}
          <ChevronDown className="h-4 w-4 flex-shrink-0 text-telekinesis-text-secondary" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className={pickerContentClass}
        style={{ minWidth: 'var(--radix-dropdown-menu-trigger-width)' }}
      >
        {DOMAINS.map((opt) => (
          <DropdownMenuItem
            key={opt.value}
            onClick={() => handleDomainSelect(opt.value)}
            className={cn(
              pickerHeroItemBaseClass,
              currentDomain === opt.value
                ? pickerItemActiveClass
                : pickerItemInactiveClass,
            )}
          >
            <span className="font-medium">{opt.label}</span>
            {opt.hero && (
              <div className={pickerHeroWrapperClass}>
                <img
                  src={opt.hero}
                  alt=""
                  aria-hidden="true"
                  className="h-full object-contain"
                  style={
                    opt.value === 'sea' || opt.value === 'space'
                      ? { transform: 'scaleX(-1)' }
                      : undefined
                  }
                />
              </div>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
